/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ComponentTwinsGroupResponseDto,
  CreateComponentTwinsGroupRequestDto,
  ListComponentTwinsGroupsResponseDto,
  UpdateComponentTwinsGroupRequestDto,
} from '../models/index';
import {
    ComponentTwinsGroupResponseDtoFromJSON,
    ComponentTwinsGroupResponseDtoToJSON,
    CreateComponentTwinsGroupRequestDtoFromJSON,
    CreateComponentTwinsGroupRequestDtoToJSON,
    ListComponentTwinsGroupsResponseDtoFromJSON,
    ListComponentTwinsGroupsResponseDtoToJSON,
    UpdateComponentTwinsGroupRequestDtoFromJSON,
    UpdateComponentTwinsGroupRequestDtoToJSON,
} from '../models/index';

export interface ComponentTwinsGroupControllerCreateRequest {
    assetId: string;
    organizationId: string;
    createComponentTwinsGroupRequestDto: CreateComponentTwinsGroupRequestDto;
}

export interface ComponentTwinsGroupControllerDeleteRequest {
    groupId: string;
    assetId: string;
    organizationId: string;
}

export interface ComponentTwinsGroupControllerGetByIdRequest {
    groupId: string;
    assetId: string;
    organizationId: string;
}

export interface ComponentTwinsGroupControllerListRequest {
    assetId: string;
    organizationId: string;
}

export interface ComponentTwinsGroupControllerUpdateRequest {
    groupId: string;
    assetId: string;
    organizationId: string;
    updateComponentTwinsGroupRequestDto: UpdateComponentTwinsGroupRequestDto;
}

/**
 * 
 */
export class ComponentTwinsGroupsApi extends runtime.BaseAPI {

    /**
     */
    async componentTwinsGroupControllerCreateRaw(requestParameters: ComponentTwinsGroupControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComponentTwinsGroupResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling componentTwinsGroupControllerCreate().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling componentTwinsGroupControllerCreate().'
            );
        }

        if (requestParameters['createComponentTwinsGroupRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createComponentTwinsGroupRequestDto',
                'Required parameter "createComponentTwinsGroupRequestDto" was null or undefined when calling componentTwinsGroupControllerCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/component-twins-groups`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateComponentTwinsGroupRequestDtoToJSON(requestParameters['createComponentTwinsGroupRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComponentTwinsGroupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentTwinsGroupControllerCreate(requestParameters: ComponentTwinsGroupControllerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComponentTwinsGroupResponseDto> {
        const response = await this.componentTwinsGroupControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentTwinsGroupControllerDeleteRaw(requestParameters: ComponentTwinsGroupControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling componentTwinsGroupControllerDelete().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling componentTwinsGroupControllerDelete().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling componentTwinsGroupControllerDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/component-twins-groups/{groupId}`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async componentTwinsGroupControllerDelete(requestParameters: ComponentTwinsGroupControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.componentTwinsGroupControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async componentTwinsGroupControllerGetByIdRaw(requestParameters: ComponentTwinsGroupControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComponentTwinsGroupResponseDto>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling componentTwinsGroupControllerGetById().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling componentTwinsGroupControllerGetById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling componentTwinsGroupControllerGetById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/component-twins-groups/{groupId}`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComponentTwinsGroupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentTwinsGroupControllerGetById(requestParameters: ComponentTwinsGroupControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComponentTwinsGroupResponseDto> {
        const response = await this.componentTwinsGroupControllerGetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentTwinsGroupControllerListRaw(requestParameters: ComponentTwinsGroupControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListComponentTwinsGroupsResponseDto>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling componentTwinsGroupControllerList().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling componentTwinsGroupControllerList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/component-twins-groups`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListComponentTwinsGroupsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentTwinsGroupControllerList(requestParameters: ComponentTwinsGroupControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListComponentTwinsGroupsResponseDto> {
        const response = await this.componentTwinsGroupControllerListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async componentTwinsGroupControllerUpdateRaw(requestParameters: ComponentTwinsGroupControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComponentTwinsGroupResponseDto>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling componentTwinsGroupControllerUpdate().'
            );
        }

        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling componentTwinsGroupControllerUpdate().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling componentTwinsGroupControllerUpdate().'
            );
        }

        if (requestParameters['updateComponentTwinsGroupRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateComponentTwinsGroupRequestDto',
                'Required parameter "updateComponentTwinsGroupRequestDto" was null or undefined when calling componentTwinsGroupControllerUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/assets/{assetId}/component-twins-groups/{groupId}`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateComponentTwinsGroupRequestDtoToJSON(requestParameters['updateComponentTwinsGroupRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComponentTwinsGroupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async componentTwinsGroupControllerUpdate(requestParameters: ComponentTwinsGroupControllerUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComponentTwinsGroupResponseDto> {
        const response = await this.componentTwinsGroupControllerUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
